export function findStrokes(
  strokeArray,
  { xFactor, yFactor },
  { width, height }
) {
  let customArray = [];
  if (strokeArray.length > 0) {
    for (let index = 0; index < strokeArray.length; index++) {
      const strokeObject = strokeArray[index];
      if (strokeObject.ShapeType === "path" || strokeObject.Data.length > 0) {
        let data = [];
        if (strokeObject.Data !== null && strokeObject.Data.length > 0) {
          data = strokeObject.Data.map((c) => {
            return {
              x: c[0] * xFactor,
              y: c[1] * yFactor,
            };
          });
        }
        customArray.push({
          id: strokeObject.ID,
          color:
            strokeObject.Color === "#00000" ? "#0a0a0a" : strokeObject.Color,
          points: data,
          width: strokeObject.Width,
          isDeleted: strokeObject.IsDeleted,
        });
      }
    }
  } else {
    customArray.push({
      id: 666666,
      color: "#000000",
      points: [{ x: 0, y: 0 }],
      width: 0.001,
      isDeleted: false,
    });
  }

  return customArray;
}

export function convertToCommonFormat(strokeArray, { width, height }) {
  const commonStrokeArray = [];
  strokeArray.forEach((stroke) => {
    const convertedData = [];
    stroke.points.forEach((point) =>
      convertedData.push({
        x: (point.x / width) * 100,
        y: (point.y / height) * 100,
      })
    );
    commonStrokeArray.push({
      id: stroke.id,
      userId: stroke.userId,
      color: stroke.color,
      width: stroke.width,
      isDeleted: stroke.isDeleted,
      elapsedTime: stroke.elapsedTime,
      points: convertedData,
      startTime: stroke.startTime,
    });
  });
  return commonStrokeArray;
}

export function convertToWebFormat(strokeArray, { width, height }) {
  const commonStrokeArray = [];
  strokeArray.forEach((stroke) => {
    const convertedData = [];
    stroke.points.forEach((point) =>
      convertedData.push({
        x: (point.x * width) / 100,
        y: (point.y * height) / 100,
      })
    );
    commonStrokeArray.push({
      id: stroke.id,
      userId: stroke.userId,
      color: stroke.color,
      width: stroke.width,
      isDeleted: stroke.isDeleted,
      elapsedTime: stroke.elapsedTime,
      points: convertedData,
      startTime: stroke.startTime,
    });
  });
  return commonStrokeArray;
}

export function convertToCommonFormatExpand(strokeArray, { width, height }) {
  const commonStrokeArray = [];
  strokeArray.forEach((stroke) => {
    const convertedData = [];
    stroke.points.forEach((point) =>
      convertedData.push({
        x: (point.x / width) * 100,
        y: (point.y / height) * 100,
      })
    );
    commonStrokeArray.push({
      id: stroke.id,
      userId: stroke.userId,
      color: stroke.color,
      width: stroke.width,
      isDeleted: stroke.isDeleted,
      elapsedTime: stroke.elapsedTime,
      points: convertedData,
      startTime: stroke.startTime,
      replayBoxId: stroke.replayBoxId,
    });
  });
  return commonStrokeArray;
}

export function convertToWebFormatExpand(strokeArray, { width, height }) {
  const commonStrokeArray = [];
  strokeArray.forEach((stroke) => {
    const convertedData = [];
    stroke.points.forEach((point) =>
      convertedData.push({
        x: (point.x * width) / 100,
        y: (point.y * height) / 100,
      })
    );
    commonStrokeArray.push({
      id: stroke.id,
      userId: stroke.userId,
      color: stroke.color,
      width: stroke.width,
      isDeleted: stroke.isDeleted,
      elapsedTime: stroke.elapsedTime,
      points: convertedData,
      startTime: stroke.startTime,
      replayBoxId: stroke.replayBoxId,
    });
  });
  return commonStrokeArray;
}

export function translateStroke(stroke, translateY, translateX) {
  const strokeData = [...stroke.points];
  let expandData = stroke;
  let modifiedStrokeData = [];
  strokeData.map((s) => {
    let x = s.x - translateX;
    let y = s.y - translateY;
    modifiedStrokeData.push({ x: x, y: y });
  });
  expandData.points = modifiedStrokeData;
  return expandData;
}

export function translateShapesToExpand(shapes, translateY, translateX) {
  let expandData = JSON.parse(JSON.stringify(shapes));
  let x = 0;
  let y = 0;
  x = expandData.ShapeLeft - translateX;
  y = expandData.ShapeTop - translateY;
  expandData.ShapeLeft = x;
  expandData.ShapeTop = y;

  return expandData;
}

export function translateStrokeToParent(
  stroke,
  translateY,
  translateX,
  { width, height },
  { xAxis, yAxis }
) {
  const strokeData = [...stroke.points];
  let expandData = stroke;
  let modifiedStrokeData = [];
  strokeData.map((s) => {
    let xCoord = s.x - translateX;
    let yCoord = s.y - translateY;
    if (xCoord <= xAxis && yCoord <= yAxis) {
      modifiedStrokeData.push({ x: xCoord, y: yCoord });
    }
  });
  if (modifiedStrokeData.length > 0) {
    expandData.points = modifiedStrokeData;
    return expandData;
  }
  return null;
}

export function findContainsExplicitStrokes(strokeArray, maxPoint) {
  const { maxX, maxY } = maxPoint;
  let hasExplicitStrokes = false;
  for (let i = 0; i < strokeArray.length; i++) {
    strokeArray[i].points.map((s) => {
      let x = s.x;
      let y = s.y;
      if (parseFloat(x) >= maxX || parseFloat(y) >= maxY) {
        hasExplicitStrokes = true;
      }
    });
    if (hasExplicitStrokes) {
      break;
    }
  }
  return hasExplicitStrokes;
}
